import {Component, OnInit, ViewChild, ElementRef, Inject, Renderer2, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialModule } from '../../material.module';
import {FormBuilder, FormGroup, Validators, ValidationErrors, AbstractControl} from '@angular/forms';
import { EmployeeAddRequest } from 'src/app/_model/request/EmployeeAddRequest';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { LookupService } from 'src/app/_services/lookup.service';
import { AbsReportService, ReportRequest } from 'src/app/_services/absreport.service';
import { EmployeeService } from 'src/app/_services/employee.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { Employee } from 'src/app/_model/Employee';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { User } from 'src/app/_model/user';
import { operations } from 'src/app/_model/constants';
import { EmployeeUpdateRequest } from 'src/app/_model/request/EmployeeUpdateRequest';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
import { EmployeeIdariRequest } from 'src/app/_model/request/EmployeeIdariRequest';
import { EmployeeIdariDeleteComponent } from './employeeIdari-delete/employeeIdari-delete.component';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {AppConstants, DIALOG_OPERATIONS} from '../../_utils/constants';
import {PhonePipe} from '../../_pipe/phonepipe';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {DialogCloseData} from '../../_model/models';
import {environment} from '../../../environments/environment';
import {FileNameData} from '../../_model/FileNameData';
import {UtilityService} from '../../_helpers/utility.service';
const moment =  _moment;
declare var $: any;

@Component({
  selector: 'app-employee-add', 
  templateUrl: './employee-add.component.html',
  styleUrls: ['./employee-add.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatTabsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MaterialModule
  ],
  providers: [
    FormBuilder,
    LookupService,
    EmployeeService,
    ToastrService,
    DatePipe,
    PhonePipe,
    AuthenticationService,
    AbsReportService,
    UtilityService
  ]
})
export class EmployeeAddComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  displayedColumns: string[] = ['effectiveStartDate', 'effectiveEndDate', 'explanation', 'actions'];
  dsemployeeIdari: MatTableDataSource<EmployeeIdariRequest>;
  employeeIdariList: EmployeeIdariRequest[];
  employeeAddForm: FormGroup;
  selectedType: any = null;
  selectedLocation: any = null;
  currentUser: User;
  captchaResponse: string = '';
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
  employeeAddRequest: EmployeeAddRequest = new EmployeeAddRequest();
  employeeIdariRequest: EmployeeIdariRequest= new EmployeeIdariRequest();
  employeeUpdateRequest: EmployeeUpdateRequest = new EmployeeUpdateRequest();
  absReportRequest: ReportRequest = new ReportRequest();
  submitButtonName: string = 'Kaydet';
  submitted = false;
  loadingTicketForm: boolean = true;
  departmentList: any = [];
  parentDepartmentList: any = [];
  filteredDepartmentList: any = [];
  genderList: any = [];
  selectedDepartment: any;
  titleList: any = [];
  managerList: any = [];
  filteredManagerList: Observable<any[]>;
  filteredApprovalManager: Observable<any[]>;
  operationName: string;
  bsConfig: Partial<BsDatepickerConfig>;
  selectedEmployeeIdari: EmployeeIdariRequest;
  gsm: any;
  formattedGsm: any;

  // file upload variables
  fileData: File = null;
  fileUploadProgress: string = null;
  fileUploadRoot = environment.fileUploadPath;
  fileNameData: FileNameData = new FileNameData(null, null);
  filePath = null;

  // update modal variables
  isImageChanged = false;

  @ViewChild('profilePhotoInput', {static: false}) profilePhotoInput: ElementRef;

  constructor(private formBuilder: FormBuilder,
              private lookupService: LookupService,
              private employeeService: EmployeeService,
              private toastr: ToastrService,
              private route: ActivatedRoute,
              public  dialog: MatDialog,
              private router: Router,
              private datePipe: DatePipe,
              public  dialogRef: MatDialogRef<EmployeeAddComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Employee,
              private authService: AuthenticationService,
              private phonePipe: PhonePipe,
              private utilityService: UtilityService,
              private ref: ChangeDetectorRef,
              private absReportService: AbsReportService,) {
    this.currentUser = authService.currentUserValue;

  }

  ngOnInit() {

    // TODO captcha off
    // this.addRecaptchaScript();
    this.createemployeeForm();
    this.initializeLookUp();
    this.bsConfig = { dateInputFormat: 'DD.MM.YYYY', selectFromOtherMonth: true };

    this.employeeService.getTopManagers().subscribe(result => {
        this.managerList = result.responseData.items.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'tr')
        );
        this.filteredManagerList = this.employeeAddForm.controls.employeeGenel.get('managerId').valueChanges
            .pipe(
                startWith(''),
                map(value => this.filterManagerList(value))
            );
        this.filteredApprovalManager = this.employeeAddForm.controls.employeeGenel.get('approvalManagerId').valueChanges
            .pipe(
                startWith(''),
                map(value => this.filterManagerList(value))
            );
    });
  }

  private filterManagerList(value: string): string[] {
      if (value === undefined) {
          return this.managerList;
      }
      const filterValue = value.toLowerCase();
      return this.managerList.filter(manager => (manager.name + ' ' + manager.surname).toLowerCase().includes(filterValue));
  }

  createemployeeForm() {
    this.employeeAddForm = this.formBuilder.group({
      employeeGenel: this.formBuilder.group({
        name: ['', [Validators.required]],
        surname: ['', [Validators.required]],
        tckn: ['', [Validators.required, this.utilityService.tckn]],
        email: ['', [Validators.required, Validators.email]],
        gsm: ['', [
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17)]],
        startofdate: ['', [Validators.required]],
        parentDepartmentId: [, [Validators.required]],
        departmentId: [, [Validators.required]],
        titleId: [, [Validators.required]],
        managerId: [''] ,
        birthDate: ['', [Validators.required]],
        gender: [, [Validators.required]],
        approvalManagerId: [''],
        endofdate: [''],
        personalNo: [''],
        mealCardNo: [''],
      }),
      employeeIdari: this.formBuilder.group({
        startdate: [''],
        enddate: [''],
        description: ['', Validators.required],
      }),

      employeeAbsReportForm: this.formBuilder.group({
        repstart: ['',Validators.required],
        repend: ['',Validators.required],
      })

    });

    // DOCUMENTATION: gsm alani icin pipe boyle calisiyor
    this.employeeAddForm.controls.employeeGenel.get('gsm').valueChanges.subscribe(val => {
      const maskedVal = this.phonePipe.transform(val);
      if (val !== maskedVal) {
        this.employeeAddForm.controls.employeeGenel.patchValue({gsm: maskedVal});
      }
    });
  }

  update() {
    this.employeeUpdateRequest = {
      name: this.employeeAddForm.controls.employeeGenel.get('name').value,
      surname: this.employeeAddForm.controls.employeeGenel.get('surname').value,
      tel: this.employeeAddForm.controls.employeeGenel.get('gsm').value,
      email: this.employeeAddForm.controls.employeeGenel.get('email').value,
      personalNo: this.employeeAddForm.controls.employeeGenel.get('personalNo').value,
      mealCardNo: this.employeeAddForm.controls.employeeGenel.get('mealCardNo').value,
      tck: this.employeeAddForm.controls.employeeGenel.get('tckn').value,
      workStartDate: this.datePipe.transform(this.employeeAddForm.controls.employeeGenel.get('startofdate').value, 'dd.MM.yyyy HH:00'),
      parentDepartmentId: this.employeeAddForm.controls.employeeGenel.get('parentDepartmentId').value,
      departmentId: this.employeeAddForm.controls.employeeGenel.get('departmentId').value,
      jobTitleId: this.employeeAddForm.controls.employeeGenel.get('titleId').value,
      managerId: this.employeeAddForm.controls.employeeGenel.get('managerId').value.id,
      birthDate : this.datePipe.transform(this.employeeAddForm.controls.employeeGenel.get('birthDate').value, 'dd.MM.yyyy HH:00'),
      gender : this.employeeAddForm.controls.employeeGenel.get('gender').value,
      approvalManagerId: this.employeeAddForm.controls.employeeGenel.get('approvalManagerId').value.id,
      endDate: this.datePipe.transform(this.employeeAddForm.controls.employeeGenel.get('endofdate').value, 'dd.MM.yyyy HH:00'),
      id: this.data.id
    };


    // yeni resim yuklendi ise onu da gonder
    if (this.isImageChanged) {
        this.employeeUpdateRequest.profilePhoto = this.fileNameData;
    }

    this.employeeService.updateEmployee(this.employeeUpdateRequest).subscribe(result => {
      this.toastr.success('Kaydetme işlemi başarılı', '');
      console.log('Result responeData item is : ' + result.responseData.item);

      this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.UPDATE, result.responseData.item));
    }, error => {
      this.toastr.error('Kaydetme islemi başarısız', '');
      this.dialogRef.close();
    });
  }

  create() {
      console.log('create');
    if (!this.employeeAddForm.controls.employeeGenel.valid) {
      this.getFormValidationErrors();
      return;
    }
    
    // Form disable etmeden önce değerleri al
    const formValues = this.employeeAddForm.controls.employeeGenel.getRawValue();
    console.log('Form values before disable:', formValues);
    
    this.employeeAddForm.disable();

    this.employeeAddRequest.name = formValues.name;
    this.employeeAddRequest.surname = formValues.surname;
    this.employeeAddRequest.tel = formValues.gsm;
    this.employeeAddRequest.email = formValues.email;
    this.employeeAddRequest.personalNo = formValues.personalNo;
    this.employeeAddRequest.mealCardNo = formValues.mealCardNo;
    if(formValues.tckn == '-'){
        this.employeeAddRequest.tck = '0';
    }else {
        this.employeeAddRequest.tck = formValues.tckn;
    };
    this.employeeAddRequest.workStartDate = this.datePipe.transform(formValues.startofdate, 'dd.MM.yyyy HH:00');
    this.employeeAddRequest.parentDepartmentId = formValues.parentDepartmentId;
    this.employeeAddRequest.departmentId = formValues.departmentId;
    this.employeeAddRequest.jobTitleId = formValues.titleId;
    this.employeeAddRequest.managerId = formValues.managerId.id;
    this.employeeAddRequest.birthDate = this.datePipe.transform(formValues.birthDate, 'dd.MM.yyyy HH:00');
    this.employeeAddRequest.gender = formValues.gender;
    this.employeeAddRequest.approvalManagerId = formValues.approvalManagerId.id;
    this.employeeAddRequest.endDate = this.datePipe.transform(formValues.endofdate, 'dd.MM.yyyy HH:00');

    // profile photo
    this.employeeAddRequest.profilePhoto = this.fileNameData;

    console.log('employeeAddRequest:', this.employeeAddRequest);
    console.log('departmentId:', this.employeeAddRequest.departmentId);
    console.log('parentDepartmentId:', this.employeeAddRequest.parentDepartmentId);

    this.employeeService.addEmployee(this.employeeAddRequest).subscribe(result => {
      this.toastr.success('Kullanıcı oluşturuldu.', 'Başarılı');
      this.employeeAddForm.enable();
      this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.CREATE, result.responseData.item));
    }, error => {
      this.toastr.error(error, 'Hata');
      this.employeeAddForm.enable();
    });

  }

  initializeLookUp() {
    const allDepartments = this.lookupService.localListByLookupCode('DEPARTMENT').sort((a, b) =>
        a.lookupValue.toLowerCase().localeCompare(b.lookupValue.toLowerCase(), 'tr')
    );
    
    // Parent Department: parentLookup null olanlar
    this.parentDepartmentList = allDepartments.filter(dept => !dept.parentLookup || dept.parentLookup === null);
    
    // Tüm departmanları sakla
    this.departmentList = allDepartments;
    
    // Parent department değiştiğinde departmanları filtrele
    this.employeeAddForm.controls.employeeGenel.get('parentDepartmentId').valueChanges.subscribe(parentId => {
      if (parentId) {
        this.filteredDepartmentList = allDepartments.filter(dept => 
          dept.parentLookup && dept.parentLookup.id === parentId
        );
      } else {
        this.filteredDepartmentList = [];
      }
      // Parent değiştiğinde departman seçimini sıfırla
      this.employeeAddForm.controls.employeeGenel.get('departmentId').setValue(null, { emitEvent: false });
    });
    
    this.genderList = this.lookupService.localListByLookupCode(AppConstants.GENDER_LOOKUP_CODE).sort((a, b) =>
      a.lookupValue.toLowerCase().localeCompare(b.lookupValue.toLowerCase(), 'tr')
    );
    this.titleList = this.lookupService.localListByLookupCode('TITLE').sort((a, b) =>
        a.lookupValue.toLowerCase().localeCompare(b.lookupValue.toLowerCase(), 'tr')
    );
    if (!this.data || Object.keys(this.data).length === 0) {
      this.operationName = operations.CREATE;
      this.data = new Employee();
    } else {
      this.operationName = operations.UPDATE;
      this.employeeAddForm.patchValue({
        name: this.data.name,
        surname: this.data.surname,
        email: this.data.email,
        tel: this.data.tel,
        birthDate: this.data.birthDate,
        jobTitle: this.data.jobTitle,
        department: this.data.department,
        gender: this.data.gender,
        tck: this.data.tck,
        manager: this.data.manager,
        workStartDate: this.data.workStartDate,
        personalNo: this.data.personalNo,
        mealCardNo: this.data.mealCardNo
      });
      
      this.employeeService.getEmployeeIdari(this.data.id).subscribe(result => {
        this.employeeIdariList = result.responseData.items;
        this.dsemployeeIdari = new MatTableDataSource(this.employeeIdariList);
        this.dsemployeeIdari.paginator = this.paginator;
      });

      const formattedWorkStartDate = this.datePipe.transform(this.data.workStartDate, AppConstants.WORKSTARTDATE_FORMAT);

      // Önce departman bilgisinden parent'ı bul
      let parentDeptId = null;
      if (this.data.department != null) {
        const currentDept = this.departmentList.find(d => d.id === this.data.department.id);
        if (currentDept && currentDept.parentLookup) {
          parentDeptId = currentDept.parentLookup.id;
          // Parent seçilince departmanları filtrele
          this.filteredDepartmentList = this.departmentList.filter(dept => 
            dept.parentLookup && dept.parentLookup.id === parentDeptId
          );
        }
      }

      this.employeeAddForm.controls.employeeGenel.patchValue({
          name: this.data.name,
          surname: this.data.surname,
          tckn: this.data.tck,
          email: this.data.email,
          gsm: this.data.tel,
          personalNo: this.data.personalNo,
          mealCardNo: this.data.mealCardNo,
          startofdate: this.data.workStartDate,
          //startofdate: moment(formattedWorkStartDate, AppConstants.WORKSTARTDATE_FORMAT),
          parentDepartmentId: this.data.parentDepartment.id,
          departmentId: this.data.department != null ? this.data.department.id : 0,
          titleId: this.data.jobTitle != null ? this.data.jobTitle.id : 0,
          managerId: this.data.manager != null ? this.data.manager : 0,
          birthDate: this.data.birthDate ,
          gender : this.data.gender ,
          approvalManagerId: this.data.approvalManager != null ? this.data.approvalManager : 0,
          endofdate : this.data.endDate ,
      });

      if (this.data.profilePhoto) {
          this.filePath = this.data.profilePhoto.filePath;
      }
    }

  }

  openDeleteModal(employeeIdari){
    this.selectedEmployeeIdari = employeeIdari;

    const dialogRef = this.dialog.open(EmployeeIdariDeleteComponent, {
        width: '300px',
        data: employeeIdari
    });

    dialogRef.afterClosed().subscribe(result => {
        if (result.operationName === DIALOG_OPERATIONS.DELETE) {
            // tabloda ilgili satiri bul ve sil
            const deletedElementIndex = this.dsemployeeIdari.data.findIndex(val => val.id === employeeIdari.id);
            console.log("Deleted Element Index is " + deletedElementIndex);
            this.dsemployeeIdari.data.splice(deletedElementIndex, 1);
            this.dsemployeeIdari._updateChangeSubscription();
        }
    });
  }
  getFormValidationErrors() {
    Object.keys(this.employeeAddForm.controls).forEach(key => {

      const controlErrors: ValidationErrors = this.employeeAddForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }
  createEmployeeIdari(){
    this.employeeIdariRequest.effectiveStartDate =  this.datePipe.transform(this.employeeAddForm.controls.employeeIdari.get('startdate').value, 'dd.MM.yyyy');
    this.employeeIdariRequest.effectiveEndDate =  this.datePipe.transform(this.employeeAddForm.controls.employeeIdari.get('enddate').value, 'dd.MM.yyyy');
    this.employeeIdariRequest.explanation = this.employeeAddForm.controls.employeeIdari.get('description').value
    this.employeeIdariRequest.employeeId = this.data.id;
    this.employeeService.addEmployeeIdari(this.employeeIdariRequest).subscribe(result => {
      this.toastr.success('Kaydetme işlemi başarılı', '');
      this.employeeIdariList.push(this.employeeIdariRequest);
      this.dsemployeeIdari = new MatTableDataSource(this.employeeIdariList);
      this.dsemployeeIdari.paginator = this.paginator;
      this.employeeAddForm.controls.employeeIdari.reset();
    }, error => {
      this.toastr.error('Kaydetme islemi başarısız', '');
    });

  }

  createOrUpdateEmployee() {
    this.submitted = true;
    if (this.employeeAddForm.controls.employeeGenel.invalid) {
      return;
    }
    if (this.operationName === operations.UPDATE) {
      this.update();
    } else {
      this.create();
    }
  }

  closeModal() {
      this.dialogRef.close();
  }

  displayFn(manager: any): string | undefined {
      return manager ? manager.name + ' ' + manager.surname : undefined;
  }

    fileProgress(fileInput: any) {
        this.fileData = fileInput.target.files[0];
        this.uploadFile();
    }

    uploadFile() {
        const formData = new FormData();
        formData.append('file', this.fileData);

        const fileType = this.fileData.name.substr(this.fileData.name.lastIndexOf('.') + 1);
        if (AppConstants.UPLOADABLE_IMAGE_TYPES.indexOf(fileType.toLowerCase()) < 0) {
            this.toastr.warning(AppConstants.UPLOADABLE_IMAGE_TYPES + ' dosya tiplerinden birini kullanabilirsiniz', 'Dikkat');
            this.fileData = null;
            return;
        }

        const fileSizeInMb = this.fileData.size / 1024 / 1024;
        if (fileSizeInMb >= AppConstants.FILE_UPLOAD_LIMIT) {
            this.toastr.warning('Dosya boyutu en fazla ' + AppConstants.FILE_UPLOAD_LIMIT + 'mb olmalıdır', 'Dikkat');
            this.fileData = null;
            return;
        }

        this.getBase64(this.fileData).then(value => {
            this.fileNameData = new FileNameData(this.fileData.name, value);
        });

        this.isImageChanged = true;

        setTimeout(() => this.fileData = null, 500);
    }

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    deleteProfilePhoto() {
        this.profilePhotoInput.nativeElement.value = '';
        this.fileNameData = new FileNameData(null, null);
    }

    getAbsReport(){
      this.absReportRequest = {
        reportId : 1,
        parameters : [{name:"employeeId",value: this.data.id+"" },
        {name:"repStart",value: this.datePipe.transform(this.employeeAddForm.controls.employeeAbsReportForm.get('repstart').value, 'dd.MM.yyyy')},
        {name:"repEnd",value:this.datePipe.transform(this.employeeAddForm.controls.employeeAbsReportForm.get('repend').value, 'dd.MM.yyyy')}
        ]
      };

      this.absReportService.getReport(this.absReportRequest).subscribe(result => {
          const link = document.createElement('a');
          link.setAttribute('target', '_blank');

          console.log( environment.fileUploadPath + '/absreport/' + result.responseData.item.fileName.replace('absreport','') );
          link.setAttribute('href', environment.fileUploadPath + '/absreport/' + result.responseData.item.fileName.replace('absreport','') );
          link.setAttribute('download', 'izin_dokum' + this.data.id + '.pdf');
          document.body.appendChild(link);
          link.click();
          link.remove();

      });

    }

}
